module.exports = __webpack_public_path__ + "img/thumbs.6c8ad8d0.svg";